// extracted by mini-css-extract-plugin
export default {"actionButton":"NftOffer_actionButton__8qFrw","button":"NftOffer_button__T+CGA"};